/*
 * Copyright (c) 2019 - Indigen Solutions
 * Authors:
 *   - Bichoy Messiha <bm@indigen.com>
 * NOTICE: All information contained herein is, and remains
 * the property of Indigen Solutions and its suppliers,
 * if any.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */

import { isNil } from "lodash";
import { removeCookie, setCookie } from "../utils/cookies";

export class AuthApi {
    constructor(api) {
        this._me = null;
        this.api = api;
    }

    async signIn(form) {
        const response = await this.api.post("/auth/login", form);
        this.saveUser(response.me, response.accessToken);
    }

    logout() {
        removeCookie("jwtToken");
        this.api.user.clean();
    }

    async handleFirstUse(form) {
        return await this.api.post("/auth/firstUse", form);
    }

    async resetPassword(form) {
        await this.api.patch("/auth/savePassword", form);
    }

    async handleForgotPassword(form) {
        return await this.api.post("/auth/forgotPassword", form);
    }

    saveUser(me, accessToken) {
        this.api.setAccessToken(accessToken);
        setCookie("jwtToken", accessToken, 1);
        this._me = me;
    }

    setAccessToken(accessToken) {
        this.api.setAccessToken(accessToken);
        setCookie("jwtToken", accessToken, 1);
    }

    isAdmin() {
        return (
            !isNil(this._me) &&
            !isNil(this._me.parsedAuthorities) &&
            this._me.parsedAuthorities.some(p => p === "ADMIN")
        );
    }
}
